import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { milestoneDenyChanges } from "../../../../../api-services/projects/milestones";
import {
  FEEDBACK_TYPE,
  feedbackMessage,
} from "../../../../professional/job-requests/hooks/feedbackErrors";
import { useToast } from "../../../../utils/useToast";

export const useMilestoneDenyChanges = (projectId?: string) => {
  const { projectId: paramsProjectId } = useParams();
  const { notifySuccess } = useToast();

  return useMutation(
    ({ milestoneId, isNew }: { milestoneId: string; isNew?: boolean }) =>
      milestoneDenyChanges(projectId ?? paramsProjectId, milestoneId, isNew),
    {
      onSuccess() {
        notifySuccess(feedbackMessage("milestone changes", FEEDBACK_TYPE.DENY));
      },
    }
  );
};
